/**
 * <ss-form> — the two pieces of polish on the contact form.
 *
 *   1. A characters-left counter. The textarea carries a real maxlength, so
 *      the limit holds without this file; the counter only makes it visible.
 *      It is wired through aria-describedby rather than aria-live — a live
 *      region would announce on every keystroke, which is unusable.
 *
 *   2. A submit button that is disabled until the form is valid. Note the
 *      inversion: Liquid renders the button ENABLED and this file disables it
 *      on connect. A visitor without JavaScript must always be able to submit,
 *      and `required` plus Shopify's own server-side validation are the real
 *      backstop either way.
 */
class SSForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.submit = this.form.querySelector('[data-ss-submit]');
    this.field = this.form.querySelector('[data-ss-count]');
    this.output = this.form.querySelector('[data-ss-count-out]');
    this.template = this.output?.dataset.template || '[left]';

    this.onInput = this.onInput.bind(this);
    this.form.addEventListener('input', this.onInput);
    this.form.addEventListener('change', this.onInput);
    this.onInput();
  }

  disconnectedCallback() {
    this.form?.removeEventListener('input', this.onInput);
    this.form?.removeEventListener('change', this.onInput);
  }

  onInput() {
    if (this.field && this.output) {
      const max = Number(this.field.getAttribute('maxlength'));
      const left = Number.isNaN(max) ? null : max - this.field.value.length;
      if (left !== null) {
        this.output.textContent = this.template.replace('[left]', String(left));
        /* Wording changes as well as colour, so the warning is never carried
           by colour alone. */
        this.output.classList.toggle('ss-contact__count--low', left <= 50);
      }
    }

    if (this.submit) {
      this.submit.disabled = !this.form.checkValidity();
    }
  }
}

if (!customElements.get('ss-form')) {
  customElements.define('ss-form', SSForm);
}
